module.exports = __webpack_public_path__ + "web/img/画板 2 (1).8c7ee7e6.png";